import { useFirestoreLoaded } from '../../firebase/useFirestore'
import MultiSelect from '../common/MultiSelect'
import useArrayLinkToggle from '../../hooks/useArrayLinkToggle'

/**
 * Link picker: which effects this mechanism produces.
 * Writes Mechanisms.Effect[] (by effect ID, not docid). This is the mechanism →
 * effect link the navigator follows.
 *
 * @param {object} props
 * @param {{docid: string, Effect?: string[]}} props.mechanism - The mechanism whose Effect[] link is edited.
 */
const SelectMechanismEffects = ({ mechanism }) => {
    const [effects, loaded] = useFirestoreLoaded('OutputEffects')
    const toggleLink = useArrayLinkToggle()

    const selected = Array.isArray(mechanism.Effect) ? mechanism.Effect : []

    const toggle = (id, isSelected) => toggleLink({
        collection: 'TocMechanisms',
        docid: mechanism.docid,
        field: 'Effect',
        value: id,
        isSelected,
    })

    const labelById = (effects || []).reduce((acc, e) => {
        acc[e.ID] = e.Effect
        return acc
    }, {})
    const options = (effects || []).map(e => ({ id: e.ID, label: e.Effect }))

    return (
        <MultiSelect
            selected={selected}
            options={options}
            onToggle={toggle}
            loaded={loaded}
            renderSelected={(id) => <span>{labelById[id] || id}</span>}
            addLabel='+ Effect toevoegen'
            emptyLabel='Geen effect(en) gekoppeld'
            emptyOptionsLabel='Geen effecten beschikbaar'
            removeAriaLabel='Verwijder effect'
        />
    )
}

export default SelectMechanismEffects
